module.exports = __webpack_public_path__ + "img/icon-retirement-sky-blue.1c82c03e.svg";